import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
// Types
import { TicketEventDetailsFields } from 'api/ticketing/types/TicketEventDetailsFields';
import { TicketTierFields } from 'api/ticketing/types/TicketTierFields';
import { TicketEventStatus, TicketOrderKind } from 'api/graphql-global-types';
// Components
import OrdersTable from '../OrdersTable/OrdersTable';
import IssueCompsModal from '../IssueCompsModal/IssueCompsModal';

type CompsTabProps = {
  event: TicketEventDetailsFields;
  tiers: TicketTierFields[];
};

const CompsTab = ({ event, tiers }: CompsTabProps): JSX.Element => {
  const [issueOpen, setIssueOpen] = useState(false);
  const cancelled = event.status === TicketEventStatus.Cancelled;
  const disabledReason = cancelled
    ? 'A cancelled event takes no comps.'
    : !tiers.length
    ? 'Add a ticket tier first.'
    : null;

  return (
    <>
      <OrdersTable
        event={event}
        kind={TicketOrderKind.Comp}
        toolbarActions={
          <Tooltip title={disabledReason}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              disabled={!!disabledReason}
              onClick={() => setIssueOpen(true)}
            >
              Issue comps
            </Button>
          </Tooltip>
        }
      />
      <IssueCompsModal
        ticketEventId={event.id}
        tiers={tiers}
        visible={issueOpen}
        onClose={() => setIssueOpen(false)}
        onIssued={() => setIssueOpen(false)}
      />
    </>
  );
};

export default CompsTab;
